module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[6]5.c3357a6.woff2";